<div class="animated fadeIn">
    <div class="card">
        <div class="card-header">
            Your Forms
        </div>
        <div class="card-body">

            <div *ngIf="forms && forms.length > 0">
                <p>You have access to these Sprout forms.</p>
                <table class="table">
                    <thead>
                    <tr>
                        <th style="width: 25%">Name</th>
<!--                        <th>Key</th>-->
                        <th>Processes</th>
                        <th>Re-Import</th>
                        <th>Share</th>
                        <th>Publications</th>
                        <th>Download</th>
                        <th>Delete</th>
                        <th>Activity Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--                <tr *ngFor="let study of forms | studyActive: study | filterByString: 'name' : filterText;">-->
                    <tr *ngFor="let form of forms">
                        <td>
                            <a [href]="" (click)="viewForm(form)" class="list-link">{{form.formName}}</a>
                        </td>
<!--                        <td>-->
<!--                            {{form.formKey}}-->
<!--                        </td>-->
                        <td>
                            <a *ngIf="form.privilege == 'O' || form.privilege == 'W'" [href]=""
                               (click)="onProcessBuilder(form)" class="list-link">Process Builder</a>
                        </td>
                        <td>
                            <sprout-form-upload *ngIf="form.privilege == 'O' || form.privilege == 'W'"
                                                (fileImportTOEventEmitter)="importEvent($event, form)" [button]="false"
                                                [form]="form"></sprout-form-upload>
                        </td>
                        <td>
                            <a *ngIf="form.privilege == 'O'" [href]="" (click)="onSharing(form)"
                               class="list-link">Share</a>
                        </td>
                        <td>
                            <a *ngIf="form.privilege == 'O' || form.privilege == 'W'" (click)="onPublishModal(form)"
                               class="list-link">Publications ({{form.publicationCount}})</a>
                        </td>
                        <td>
                            <a *ngIf="form.privilege == 'O' || form.privilege == 'W'" [href]=""
                               (click)="download(form)" class="list-link">Download</a>
                        </td>
                        <td>
                            <a *ngIf="form.privilege == 'O' || form.privilege == 'W'" [href]=""
                               (click)="confirmFormDeletion(form)" class="list-link">Delete</a>
                        </td>
                        <td>
                            {{form.activityDate|date:'medium'}}
                        </td>
                    </tr>
                    <!--                <tr *ngFor="let form of forms">-->
                    <!--                    <td>-->
                    <!--                        <p><code class="highlighter-rouge">&lt;h1&gt;&lt;/h1&gt;</code></p>-->
                    <!--                    </td>-->
                    <!--                    <td><span class="h1">h1. Bootstrap heading</span></td>-->
                    <!--                </tr>-->
                    </tbody>
                </table>
            </div>
            <div *ngIf="!forms || forms.length == 0">
                <alert type="info">
                    <strong>Why don't I see any forms?</strong> This page will list your forms once you have created
                    at least one form. You many <strong><a ng-reflect-router-link="/design/import"
                                                           href="#/design/import">import</a></strong>
                    a form or manually <strong><a ng-reflect-router-link="/design/import"
                                                  href="#/design/import">design</a></strong> a form.

                </alert>
            </div>


        </div>
    </div>
</div>

<div bsModal #dangerModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="ConfirmDeleteModal"
     aria-hidden="true">
    <div class="modal-dialog modal-danger" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Confirm Form Deletion</h4>
                <button type="button" class="close" (click)="dangerModal.hide()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to delete this form?</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="dangerModal.hide()">Cancel</button>
                <button type="button" class="btn btn-danger" (click)="onDeleteForm()">Yes, delete!</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div>

<div bsModal #downloadMissingModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="ConfirmDeleteModal"
     aria-hidden="true">
    <div class="modal-dialog modal-warning" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Missing Export File</h4>
                <button type="button" class="close" (click)="downloadMissingModal.hide()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>This form is missing its export file. This is likely because the <span style="font-style: italic;">Download</span> feature was introduced after this form was imported into SproutScribe.</p>
                <p>Please import the original file again to be able to use this feature.</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="downloadMissingModal.hide()">OK</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div>

<div bsModal #viewModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="ViewFormModal"
     aria-hidden="true">
    <div class="modal-dialog modal-xl  modal-sprout" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">View Form</h4>
                <button type="button" class="close" style="color: #FFFFFF" (click)="viewModal.hide()"
                        aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div *ngIf="!form || !form.model" class="alert alert-info">Loading...please wait...</div>
                <sprout-forms *ngIf="form && form.model" [model]="form"></sprout-forms>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-primary" (click)="viewModal.hide()">Close</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div>


<div bsModal #shareModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="ShareFormModal"
     aria-hidden="true">
    <div class="modal-dialog modal-xl modal-sprout" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Form Sharing</h4>
                <button type="button" class="close" style="color: #FFFFFF" (click)="shareModal.hide()"
                        aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div *ngIf="!shares || shares.length == 0">
                    <alert type="success">You haven't shared your form with anyone. Click on the share button to start
                        sharing.
                    </alert>
                </div>

                <div *ngIf="shareMode == 'list'">
                    <table class="table" *ngIf="shares && shares.length > 0">
                        <thead>
                        <tr>
                            <th>Username</th>
                            <th>Domain</th>
                            <th>Full Name</th>
                            <th>Privilege</th>
                            <!--                            <th>Revoke</th>-->
                            <th>Activity Date</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let share of shares">
                            <td>
                                {{share.username}}<span *ngIf="share.usernameFederated"> ({{share.usernameFederated}}
                                )</span>
                            </td>
                            <td>
                                {{share.domain}}
                            </td>
                            <td>
                                {{share.firstName}} {{share.lastName}}
                            </td>
                            <td>
                                {{share.privilegePretty}}
                            </td>
                            <!--                            <td>-->
                            <!--                                <a *ngIf="share.privilege != 'O'" [href]="" (click)="onRevokeShare(share)" class="list-link">Revoke</a>-->
                            <!--                            </td>-->
                            <td>
                                {{share.activityDate| date: 'medium'}}
                            </td>
                            <!--                        <td>-->
                            <!--                            {{share.activityDate|date:'medium'}}-->
                            <!--                        </td>-->
                        </tr>
                        <!--                <tr *ngFor="let form of forms">-->
                        <!--                    <td>-->
                        <!--                        <p><code class="highlighter-rouge">&lt;h1&gt;&lt;/h1&gt;</code></p>-->
                        <!--                    </td>-->
                        <!--                    <td><span class="h1">h1. Bootstrap heading</span></td>-->
                        <!--                </tr>-->
                        </tbody>
                    </table>
                </div>

                <div *ngIf="shareMode == 'edit'">
                    <form [formGroup]="editShareForm">

                        <div class="form-group pt-3">
                            <h4 for="inputSearchShareUser">Find user</h4>
                            <input #inputSearchShareUser formControlName="search" type="text" class="form-control"
                                   id="inputSearchShareUser" aria-describedby="inputSearchShareUser"
                                   placeholder="">
                            <small class="text-muted">Enter username, full name, or email address.</small>
                        </div>
                    </form>

                    <table class="table" *ngIf="shareUserSearchResults && shareUserSearchResults.length > 0">
                        <thead>
                        <tr>
                            <th>Username</th>
                            <th>Domain</th>
                            <th>Full Name</th>
                            <th>Permission</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let user of shareUserSearchResults">
                            <!--                            <td [ngClass]="{'text-muted': user.privilege}">-->
                            <td [ngClass]="{'text-muted': user.privilege && user.privilege == 'O'}">
                                {{user.username}}<span *ngIf="user.usernameFederated"> ({{user.usernameFederated}}
                                )</span>
                            </td>
                            <td [ngClass]="{'text-muted': user.privilege && user.privilege == 'O'}">
                                {{user.domain}}
                            </td>
                            <td [ngClass]="{'text-muted': user.privilege && user.privilege == 'O'}">
                                {{user.firstName}} {{user.lastName}}
                            </td>
                            <td class="privilege-edit-col"
                                [ngClass]="{'text-muted': user.privilege && user.privilege == 'O'}">
                                <span *ngIf="user.privilege != 'O'">
                                    <mat-radio-group [(ngModel)]="user.privilege" (change)="onSavePrivilege(user)"
                                                     color="primary" aria-label="Select privilege">
                                      <mat-radio-button value="R">Read</mat-radio-button>
                                      <mat-radio-button value="W">Write</mat-radio-button>
                                    </mat-radio-group>
                                    <button color="warn" class="button24" mat-mini-fab
                                            [disabled]="!user.privilege || user.privilege == 'O'"
                                            (click)="onRevokeShareUser(user)">
                                        <mat-icon class="icon24">clear</mat-icon>
                                    </button>
                                </span>
                                <span *ngIf="user.privilege == 'O'" style="font-style: italic;" class="text-muted">
                                    Owner (immutable)
                                </span>
                            </td>
                            <!--                            <td [ngClass]="{'text-muted': user.privilege}">-->
                            <!--                                <span *ngIf="!pickPrivilegeUser">-->
                            <!--                                    <span *ngIf="!user.privilege">-->
                            <!--                                        <a [href]="" (click)="onShare(user)" class="list-link">Share</a>-->
                            <!--                                    </span>-->
                            <!--                                </span>-->
                            <!--                                <span *ngIf="pickPrivilegeUser && pickPrivilegeUser.userId == user.userId">-->
                            <!--                                    <mat-radio-group [(ngModel)]="sharePrivilegeChoice" (change)="onSavePrivilege()" color="primary" aria-label="Select privilege">-->
                            <!--                                      <mat-radio-button value="R">Read</mat-radio-button>-->
                            <!--                                      <mat-radio-button value="W">Write</mat-radio-button>-->
                            <!--                                    </mat-radio-group>-->
                            <!--                                </span>-->
                            <!--                            </td>-->
                        </tr>
                        </tbody>
                    </table>

                    <div class="alert alert-info"
                         *ngIf="this.editShareForm.controls.search.value && shareUserSearchInit && (!shareUserSearchResults || shareUserSearchResults.length == 0)">
                        Sorry, no active users found with that name in SproutScribe. Please modify your search.
                    </div>

                </div>


            </div>
            <div class="modal-footer">
                <div class="text-right" *ngIf="shareMode == 'list'">
                    <button (click)="onEditShare()" mat-raised-button color="warn" aria-label="Edit Shares"
                            matTooltip="Edit/Add form shares.">
                        <mat-icon>edit</mat-icon> Edit Shares
                    </button>
                    <button (click)="shareModal.hide()" mat-raised-button color="primary" aria-label="Close" matTooltip="Close">
                        <mat-icon>check</mat-icon> Close
                    </button>
                </div>
<!--                <div class="text-right" *ngIf="shareMode == 'list'">-->
<!--                    <button (click)="onEditShare()" mat-fab color="warn" aria-label="Edit Shares"-->
<!--                            matTooltip="Edit/Add form shares.">-->
<!--                        <mat-icon>edit</mat-icon>-->
<!--                    </button>-->
<!--                    <button (click)="shareModal.hide()" mat-fab color="primary" aria-label="Close" matTooltip="Close">-->
<!--                        <mat-icon>check</mat-icon>-->
<!--                    </button>-->
<!--                </div>-->
                <div *ngIf="shareMode == 'edit'">
                    <span *ngIf="shareSavedInd">
                        Saved!
                    </span>

                    <div class="text-right">
                        <button (click)="onListShares()" mat-raised-button color="primary" aria-label="View shares list"
                                matTooltip="View list of shares for this form.">
                            <mat-icon>check</mat-icon> Done
                        </button>
                    </div>

                </div>
                <!--                <button type="button" class="btn btn-outline-primary" (click)="shareModal.hide()">Close</button>-->
                <!--                <button type="button" mat-fab color="primary" (click)="shareModal.hide()">Close</button>-->
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div>


<div bsModal #publishModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="publishFormModal"
     aria-hidden="true">
    <div class="modal-dialog modal-md modal-sprout" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Form Publications</h4>
                <button type="button" class="close" style="color: #FFFFFF" (click)="publishModal.hide()"
                        aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">


                <div *ngIf="publicationMode == 'list'">
                    <div *ngIf="!publications || publications.length == 0" class="alert alert-info">
                        This form has not been published before. Click on the Publish button to publish this form.
                    </div>

                    <div *ngIf="publications && publications.length > 0">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Key</th>
                                <th>Actions</th>
                                <th>Activity Date</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let publication of publications">
                                <td>
                                    {{publication.name}}
                                </td>
                                <td>
                                    {{publication.publicationKey}}
                                </td>
                                <td>
                                    Actions
                                </td>
                                <td>
                                    {{publication.activityDate| date: 'medium'}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div *ngIf="publicationMode == 'name'">
                    <form [formGroup]="publishForm">
                        <mat-form-field>
                            <input matInput matInputAutofocus #inputProcessName formControlName="name" type="text" id="inputProcessName"
                                   aria-describedby="inputProcessName"
                                   placeholder="Name">
                        </mat-form-field>



                    </form>
                </div>

            </div>
            <div class="modal-footer">
                <div>
                    <span *ngIf="publishedInd">
                        Published!
                    </span>

                    <div class="text-right">
                        <button *ngIf="publicationMode == 'name'" [disabled]="publishForm.invalid" (click)="onPublish()" mat-raised-button color="primary" aria-label="Publish form"
                                matTooltip="Complete Publication">
                            Complete Publication
                        </button>
                        <button *ngIf="publicationMode == 'list'" (click)="onGetPublicationName()" mat-raised-button color="primary" aria-label="Publish form"
                                matTooltip="Publish form">
                            Publish Form
                        </button>
                        <button (click)="onCancelPublication()" mat-raised-button aria-label="Cancel publication"
                                matTooltip="Cancel form publication">
                            Close
                        </button>
                    </div>

                </div>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div>
